// extracted by mini-css-extract-plugin
module.exports = {"title":"tnc-module__title___wk2wP","content":"tnc-module__content___nAq3+"};